import { useAuth } from 'react-oidc-context';

import LoadingButton from '../components/LoadingButton';
import { useToFetchTrainingTools } from '../hooks/useToFetchTraningTools';
import { useToPreviewTrainingTools } from '../hooks/usePreviewTrainingTools';
import { useEffect, useState } from 'react';
import { TrainingToolPreviewer } from './TrainingToolPreviewer';
import Loading from './Loading';

export function DoctorTrainingToolsList() {
  const { user } = useAuth();
  const [resources, isLoading] = useToFetchTrainingTools(user!.access_token);
  const {
    handlePreviewFiles,
    previewUrl,
    profileName,
    previewBlob,
    closePreview,
    activeButtonIndex,
    isPreviewLoading,
  } = useToPreviewTrainingTools(user!.access_token);
  const [open, setOpen] = useState<boolean>(false);
  const [isVideo, setIsVideo] = useState<boolean>(false);

  useEffect(() => {
    if (!previewBlob) return;

    if (previewBlob?.type.startsWith('video/')) {
      setOpen(true);
      setIsVideo(true);
      return;
    }
    setOpen(false);
    setIsVideo(false);
  }, [previewBlob]);

  if (isPreviewLoading || isLoading) {
    return <Loading />;
  }

  if (!resources?.length) {
    return (
      <p className="font-semibold text-center overflow-hidden">
        No Resources to display
      </p>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4 pb-16">
        {resources.map((resource, index) => (
          <div
            key={index}
            className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow"
          >
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                {resource.resourceName}
              </h3>
            </div>
            <div className="flex justify-end px-4 py-4 sm:px-6">
              <LoadingButton
                key={resource.resourceId}
                className="!w-fit !text-sm !font-medium !m-2 !rounded-md !shadow-sm"
                isLoading={activeButtonIndex === resource.resourceId}
                buttonText={'View'}
                isDisabled={activeButtonIndex === resource.resourceId}
                onClick={() => {
                  handlePreviewFiles(
                    resource.resourceId,
                    resource.resourceName,
                  );
                }}
              />
            </div>
          </div>
        ))}
        {previewBlob ? (
          <TrainingToolPreviewer
            open={open}
            isVideo={isVideo}
            previewUrl={previewUrl}
            profileName={profileName}
            previewBlob={previewBlob}
            closePreview={closePreview}
            setOpen={setOpen}
          />
        ) : null}
      </div>
    </>
  );
}
